module.exports = __webpack_public_path__ + "static/img/meditation-home-default.5cf5b22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doom-yoga/meditation-home-default.png
// module id = KcLK
// module chunks = 0